import _ from 'underscore';
import constants from '../constants/index';

const defaultState = {
	selectedColumns: [],
	selectedSubColumns: [],
	hiddenColumns: [],
	timeInterval: 30,
	columnProperty: 'day_of_week',
	subColumnProperty: 'teacher_ids'
};

export default function scheduleViewerReducer(state = defaultState, action) {
	let newState = state;
	

	switch(action.type) {
		case constants.SELECT_VIEWER_COLUMN:
			newState = Object.assign({}, newState);
			if(action.payload.selected) {
				newState.selectedColumns = newState.selectedColumns.concat([action.payload.name]);
			}
			else {
				newState.selectedColumns = _.without(newState.selectedColumns, action.payload.name);
			}
			break;

		case constants.HIDE_VIEWER_COLUMN:
			newState = Object.assign({}, newState);
			newState.hiddenColumns = newState.hiddenColumns.concat([action.payload.name]);
			break;

		case constants.UNHIDE_VIEWER_COLUMNS:
			newState = Object.assign({}, newState);
			newState.hiddenColumns = [];
			break;
			
		case constants.SELECT_VIEWER_SUBCOLUMN:
			newState = Object.assign({}, newState);
			if(action.payload.selected) {
				newState.selectedSubColumns = newState.selectedSubColumns.concat([{
					index: action.payload.index, 
					name: action.payload.name
				}]);
			}
			else {
				newState.selectedSubColumns = _.reject(newState.selectedSubColumns, column => {
					return column.index === action.payload.index &&
									column.name === action.payload.name
				});
			}
			break;
		default:
	}
	return newState;
};


/** WEBPACK FOOTER **
 ** ./src/js/reducers/schedule_viewer_reducer.js
 **/